import {observer} from "mobx-react";
import React, {useContext} from "react";
import {NoticesEntity} from "@dropDesk/domain/entities/notices/notices.entity";
import HighLightWords from "@dropDesk/presentation/components/high_light_words";
import {Tooltip} from "antd";
import {displayDateToLocale} from "@dropDesk/utils/helpers/date_helper";
import {ContainerAction} from "./styled";
import ButtonActionTable from "@dropDesk/presentation/components/buttons/button_action_table";
import {NoticeDestiny} from "@dropDesk/domain/entities/notices/notices_enum";
import {useNavigate} from "react-router-dom";
import TableGeneric from "@dropDesk/presentation/components/tables/table_generic";
import {MenuCollapsedContext} from "@dropDesk/presentation/routes/private_route";
import {useBetween} from "use-between";
import {useModalNotices} from "@dropDesk/presentation/pages/notices/ui/search/modals/visible_modal_search";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import Tag from "@dropDesk/presentation/components/tag";
import {RoutesEnum} from "@dropDesk/domain/entities/routes/routes_enum";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";


const TableSearchNotices = observer(
    ({
         searchParam,
         loading,
         permitSelectionRow,
         tableNotices,
         getDataFromPage,
         setRowSelectionNotices,
         rowSelectionNotices,
         heightGarbage,
         permissionDeleteData
     }: {
        searchParam: string,
        loading: boolean,
        permitSelectionRow: boolean,
        tableNotices: ListPaginationEntity<NoticesEntity>,
        getDataFromPage: (page: number) => void,
        setRowSelectionNotices: (user: NoticesEntity[]) => void,
        rowSelectionNotices: NoticesEntity[]
        permissionDeleteData: boolean,
        heightGarbage: number
    }) => {


        const navigate = useNavigate();
        const collapsed = useContext(MenuCollapsedContext);
        const {setVisibleModalRestore, setVisibleModalDelete} = useBetween(useModalNotices);

        const setRestore = (notices: NoticesEntity) => {
            setRowSelectionNotices([notices]);
            setVisibleModalRestore(true);
        }

        const getDestiny = (destiny: NoticeDestiny): string => {

            if (destiny === NoticeDestiny.client) {
                return 'Empresa';
            }
            if (destiny === NoticeDestiny.user) {
                return 'Atendente';
            }
            if (destiny === NoticeDestiny.allUsers) {
                return 'Todos Atendentes';
            }

            return 'Todas Empresas';

        }

        const tableColumn = [

            {
                title: 'Descrição',
                ellipsis: true,
                dataIndex: 'description',
                key: 'id',
                render: (text: string, record: NoticesEntity) => (
                    <HighLightWords
                        searchWords={searchParam}
                        textToHighlight={text}
                    />
                ),
            },
            {
                title: 'Destinatário',
                ellipsis: true,
                dataIndex: 'destiny',
                key: 'id',
                render: (text: string, record: NoticesEntity) => (
                    <span>{getDestiny(record.destiny)}</span>
                ),
            },
            {
                title: 'Temporário',
                key: 'id',
                dataIndex: 'hasTemporary',
                render: (text: string, record: NoticesEntity) => {
                    return (
                        <Tag
                            label={!record.hasTemporary ? 'Não' : 'Sim'}
                            width={44}
                        />
                    )
                }
            },
            {
                title: 'Criado em',
                ellipsis: true,
                dataIndex: 'createdAt',
                key: 'id',
                render: (text: string, record: NoticesEntity) => (
                    <span>{displayDateToLocale(text)}</span>
                ),
            },
            {
                title: '',
                key: 'action',
                width: permissionDeleteData ? 65 : 40,
                render: (text: string, record: NoticesEntity) => (
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <ContainerAction>
                            {!record.deleted && permissionDeleteData &&
                                <Tooltip placement="left" title={'Excluir Aviso'}
                                > <ButtonActionTable
                                    disabled={false}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setRowSelectionNotices([record]);
                                        setVisibleModalDelete(true);
                                    }}
                                    nameIcon={ICONS_DROPDESK.delete}
                                    isActionDelete={true}
                                /> </Tooltip>}
                            {record.deleted &&
                                <Tooltip placement="left" title={'Restaurar Aviso'}
                                > <ButtonActionTable
                                    disabled={false}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setRestore(record);
                                    }}
                                    nameIcon={ICONS_DROPDESK.restore}
                                /> </Tooltip>

                            }
                        </ContainerAction>
                    </div>
                ),
            },
        ];
        const rowSelection = {
            selectedRowKeys: rowSelectionNotices.map((notices) => notices.id),
            onChange: (selectedRowKeys: React.Key[], selectedRows: NoticesEntity[]) => {
                setRowSelectionNotices(selectedRows)
            },
            getCheckboxProps: () => ({
                disabled: false,
            }),
            preserveSelectedRowKeys: true
        };


        return (
            <TableGeneric<NoticesEntity>
                sticky={true}
                size={'small'}
                tableColumns={tableColumn}
                tableDataSource={tableNotices.data}
                onSelectedRow={(notices: NoticesEntity) => {
                    if (!notices.deleted) {
                        navigate(`${RoutesEnum.notices}/${notices.id}`);
                    } else {
                        setRestore(notices);
                    }
                }}
                loading={loading}
                labelNoResults={'Nenhum resultado encontrado na pesquisa'}
                collapsedMenu={collapsed}
                defaultCurrentPage={1}
                totalRows={tableNotices.totalRows}
                page={tableNotices.page}
                pageSize={tableNotices.limit}
                rowSelection={permitSelectionRow ? rowSelection : null}
                onChange={(page) => getDataFromPage(page - 1)}
                extraLayout={heightGarbage}
            />
        )
    })
export default TableSearchNotices;
